export default "__VITE_PUBLIC_ASSET__10a7144e__"